import React, {useState} from 'react';
// import React, { useState } from 'react/cjs/react.development';
import TodoForm from './TodoForm';
import Todo from './Todo';

export default function TodoList() {


//state array which hold all Todos 
const [todos, setTodos] = useState([]);


// add todo to list 
const addTask = task => {
  if (!task.text){
    return
  }
   const newTodos = [task, ...todos];
   setTodos(newTodos);

}


// remove todo from list 

const removeTask = id => {
  let updatedTasks = [...todos].filter(task => task.id !== id );
  setTodos(updatedTasks);
  console.log('hii');
}

// task is completed 
const completeTask = id => {
  let updatedTasks = todos.map(todo => {
    if (todo.id === id ) {
      todo.isComplete = true;
    }
    return todo;
  })
  setTodos(updatedTasks)
}

  return (
    <div>
        <TodoForm addTask={addTask}></TodoForm>
        <Todo todos={todos} completeTask ={completeTask} removeTask={removeTask}></Todo>
    </div>
  )
}
